import { Toaster as Sonner, toast } from "sonner"

// The app ships a LIGHT-ONLY palette (no `.dark` block in index.css, no
// next-themes ThemeProvider) — so the shadcn default `theme={useTheme()}`
// resolved to "system" and rendered Sonner's DARK (grey) toast surface on a
// dark-mode device, while our override classNames + CSS vars (--foreground,
// --muted-foreground, --muted) are all tuned for a WHITE toast → unreadable
// low-contrast "greyed" toast. Pin to light so toasts always match the app.
const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
